import * as E from "~/renderer/web-components/element";

import { WayfinderCategory } from "./category";

export class WayfinderList extends E.SFMLElement {
  private _anchorPositions: { anchorId: string; percent: number }[] | null = null;

  public get anchorPositions() {
    return this._anchorPositions;
  }

  public set anchorPositions(value) {
    const anchorPositions: { anchorId: string; percent: number }[] = [];
    if (value) {
      for (const position of value) {
        if (this.hasAnchor(position.anchorId)) {
          anchorPositions.push(position);
        }
      }
    }

    this._anchorPositions = anchorPositions;
  }

  public hasAnchor(anchorId: string) {
    const anchorElement = this.querySelector(`sfml-wayfinder-category[anchor-id=${anchorId}]`);
    return !!anchorElement;
  }

  public getCategoryElements(): WayfinderCategory[] {
    const elements = this.querySelectorAll("sfml-wayfinder-category");
    const categoryElements: WayfinderCategory[] = [];
    for (let i = 0, n = elements.length; i < n; ++i) {
      const element = elements[i];
      if (element instanceof WayfinderCategory) categoryElements.push(element);
    }

    return categoryElements;
  }

  public setScrollPosition(percent: number) {
    if (!this.anchorPositions) return;

    const elements = this.querySelectorAll("sfml-wayfinder-category");
    for (let i = 0, n = elements.length; i < n; ++i) {
      const element = elements[i];
      if (element instanceof WayfinderCategory) element.removeAttribute("selected");
    }

    let anchorId = null;
    for (let position of this.anchorPositions) {
      if (percent >= position.percent) {
        anchorId = position.anchorId;
      } else {
        break;
      }
    }

    if (!anchorId) return;

    const highlights = this.querySelectorAll(`sfml-wayfinder-category[anchor-id=${anchorId}]`);
    for (let i = 0, n = highlights.length; i < n; ++i) {
      const highlight = highlights[i];
      if (highlight instanceof WayfinderCategory) highlight.setAttribute("selected", "true");
    }
  }
}
customElements.define("sfml-wayfinder-list", WayfinderList);



// WEBPACK FOOTER //
// webpack://SFMLWeb/src/renderer/web-components/wayfinder/list.ts